import createRoute from '@widesk-ui/tools/createRoute';

const route = createRoute.dashboard(
	'/website_entertainments/:websiteEntertainmentId/editions',
	'website',
	'WebsiteEntertainmentDashboard',
	'Éditions du festival'
);
export default route;
